import { useEffect, useState } from 'react'

import api from '../services/api'

let cache: Record<string, boolean> | null = null
let fetchPromise: Promise<Record<string, boolean>> | null = null

const fetchFeatureFlags = (): Promise<Record<string, boolean>> => {
  if (cache) return Promise.resolve(cache)

  if (!fetchPromise) {
    fetchPromise = api.v1
      .featureFlags()
      .then((res) => {
        const record = Object.fromEntries(
          res.data.map((item) => [item.name, item.value])
        ) as Record<string, boolean>
        cache = record
        return record
      })
      .catch((error) => {
        fetchPromise = null // Allow retry on error
        throw error
      })
  }

  return fetchPromise
}

export const useFeatureFlags = (): Record<string, boolean> | null => {
  const [data, setData] = useState<Record<string, boolean> | null>(cache)

  useEffect(() => {
    if (cache) {
      setData(cache)
      return
    }

    fetchFeatureFlags()
      .then(setData)
      .catch(() => {
        // Error already handled in fetchFeatureFlags
      })
  }, [])

  return data
}
